import { createAction } from '@reduxjs/toolkit';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { BoundaryFilter } from '../boundary/mapSettingsToolsStateBoundary.state';

export const setDataLayersFilter = createAction(
  'SET_DATA_LAYERS_FILTER',
  (boundaryGroupId: BoundaryGroupId, filter: BoundaryFilter) => ({
    payload: {
      boundaryGroupId,
      filter,
    },
  })
);
